(() => {
  if (window.yokoFooterReviewsReady) return;
  window.yokoFooterReviewsReady = true;
  // Loox renders an inline widget and reports its full content height. Keep
  // scrolling in our dialog body, not in a second viewport inside the iframe.
  window.addEventListener('message', event => {
    if (event.origin !== 'https://loox.io') return;
    const frames = document.querySelectorAll('[data-yoko-reviews-dialog] iframe');
    const frame = Array.from(frames).find(item => item.contentWindow === event.source);
    if (!frame) return;
    let message = event.data;
    if (typeof message === 'string') {
      try { message = JSON.parse(message); } catch (_) { return; }
    }
    if (!message || message.frame !== 'YokoFooterStoreReviews') return;
    const body = frame.closest('.yoko-reviews-dialog__body');
    if (!body) return;
    if (message.type === 'resize') {
      const height = Number(message.height);
      if (!Number.isFinite(height) || height <= 0 || height > 1000000) return;
      const nextHeight = Math.ceil(height) + 'px';
      if (frame.style.height === nextHeight) return;
      const scrollTop = frame.style.height ? body.scrollTop : 0;
      frame.style.height = nextHeight;
      // A resized, focused cross-origin iframe can make Safari/Chrome center
      // the frame itself in its scroll container. Preserve the reader's place
      // after layout and Loox's deferred focus, including on first opening.
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (frame.closest('dialog').open) body.scrollTop = scrollTop;
      }));
    } else if (message.type === 'scroll_to_view') {
      body.scrollTop = 0;
    }
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-yoko-reviews-open]');
    if (!trigger) return;
    const dialog = trigger.closest('.yoko-footer__reviews').querySelector('[data-yoko-reviews-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    if (!dialog.dataset.ready) {
      dialog.dataset.ready = 'true';
      dialog.querySelector('[data-yoko-reviews-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('yoko-reviews-open');
        trigger.focus({preventScroll: true});
      });
    }
    const frame = dialog.querySelector('iframe');
    dialog.showModal();
    dialog.querySelector('.yoko-reviews-dialog__body').scrollTop = 0;
    if (!frame.hasAttribute('src')) frame.src = frame.dataset.src;
    document.documentElement.classList.add('yoko-reviews-open');
    dialog.querySelector('[data-yoko-reviews-close]').focus();
  });
})();
